export default {
  'debts:start': 'Чтобы оформить Kaspi&nbsp;Gold для ребенка,',
  'debts:social-debts': 'Необходимо оплатить <br/> долг по социальным <br/> платежам {0}&nbsp;₸',
  'debts:tax-debts': 'Необходимо оплатить <br/> долг по налогам {0}&nbsp;₸',
  'debts:tax-and-social-debts': 'Необходимо оплатить <br/> долг по налогам {0}&nbsp;₸ <br/> и социальным платежам {1}&nbsp;₸',
  'debts:undefined': 'Необходимо оплатить <br/> долг по налогам и/или социальным платежам',
  'debts:btn': 'Оплатить налог',
  'debts:back-to-main': 'Вернуться на Главную Kaspi.kz',
  'debts:title-how': 'Как оплатить долг?',
  'debts:hint-1': 'Обратитесь в Управление госдоходов или по номеру',
  'debts:hint-2': 'Как только долг будет погашен, <br/> вы сможете продолжить процесс'
}
